<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-row :gutter="12">
      <a-col :span="12" v-for="(apply,index) in applyList" :key="index" >
        <a-card :title="apply.postName" style="width: 300px">
          <template #extra><font color="red">{{apply.wage}}元</font></template>
          <p>报名时间: {{apply.applyTime}}</p>
          <p>公司名称: {{apply.companyName}}</p>
        </a-card>
      </a-col>
    </a-row>
  </a-drawer>
</template>

<script>
import { queryApplyListById } from '@/api/biz/user'
export default {
  name: 'ApplyForm',
  data () {
    return {
      formTitle: null,
      open: false,
      applyList: []
    }
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList(id) {
      this.open = true
      this.formTitle = '报名记录'
      const param = { id: id }
      queryApplyListById(param).then(response => {
        this.applyList = response.data
      })
    },
    onClose () {
      this.open = false
    }
  }
}

</script>

<style scoped>

</style>
